// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  OrientationVersion,
} from "./types";

export default {
  orientationId: __t.string(),
  projectId: __t.string(),
  displayName: __t.string(),
  occupationTarget: __t.array(__t.string()),
  description: __t.string(),
  autoAssign: __t.bool(),
  get defaultVersion() {
    return OrientationVersion;
  },
};
